import { render, staticRenderFns } from "./addSetting.vue?vue&type=template&id=5783dd50&scoped=true&"
import script from "./addSetting.vue?vue&type=script&lang=js&"
export * from "./addSetting.vue?vue&type=script&lang=js&"
import style0 from "./addSetting.vue?vue&type=style&index=0&id=5783dd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5783dd50",
  null
  
)

export default component.exports